import { createWebHistory, createRouter } from "vue-router";


window.location.href = "https://new-chat-ai.synergy.ru/";

const routes = [
    { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
